<template>
  <div class="row m-0 ">
    <div class="col-12">
      <div class="row m-0 form_holder">
        <div class="p-0 material-icons close pointer" @click="$emit('close', false)">
          close
        </div>
        <div class="col-12 mb-3">
          <div class="label wrap_text">Name</div>
          <input type="text" v-model="myItem.title" placeholder="Product Name" class="form-control w-100">
        </div>
        <div class="col-12 mb-3">
          <div class="label wrap_text">Thumbnail</div>
          <div class="col-6 col-sm-4 col-md-4 col-lg-5 col-xl-4 pointer p-0" @click="editImage = true">
            <img :src="myItem.thumbnail_url" alt="" class="img-fluid img_height img_bg" v-if="myItem.thumbnail_url">
            <img src="../../assets/images/placeholder-square.png" alt="" class="img-fluid img_bg" v-else>
            <div class="edit_icon">
              <span class="material-icons" @click="$emit('editimg')">
                edit
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="label wrap_text bold pointer" @click="editGallery = true">
            <span class="col-auto material-icons pointer p-0 ion">add_to_photos</span>
            Other Images
          </div>
        </div>
        <div class="col-12 pointer" @click="featureIt">
          <div class="row m-0">
            <div class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-1 pl-0">
              Featured
            </div>
            <div class="col-auto p-0 text-right">
              <span class="material-icons toggle_off" v-if="!myItem.featured">
                toggle_off
              </span>
              <span class="material-icons toggle_on" v-else>
                toggle_on
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 pointer" @click="disableIt">
          <div class="row m-0">
            <div class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-1 pl-0">
              Active
            </div>
            <div class="col-auto p-0 text-right">
              <span class="material-icons toggle_off" v-if="myItem.disabled">
                toggle_off
              </span>
              <span class="material-icons toggle_on" v-else>
                toggle_on
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 mb-1 pointer" @click="soldOut">
          <div class="row m-0">
            <div class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-1 pl-0">
              In Stock
            </div>
            <div class="col-auto p-0 text-right">
              <span class="material-icons toggle_off" v-if="myItem.soldOut">
                toggle_off
              </span>
              <span class="material-icons toggle_on" v-else>
                toggle_on
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="label wrap_text">Description</div>
          <textarea rows="3" v-model="myItem.description" class="form-control p-2 w-100"></textarea>
        </div>
        <!-- <div class="col-12 p-0 mb-3">
          <div class="label wrap_text">Unit</div>
          <select v-model="myItem.unit" class="form-control hiddenSelect">
            <option v-for="unit in units" :key="unit" :value="unit">{{unit}}</option>
          </select>
        </div> -->
        <div class="col-12 mb-3">
          <div class="label wrap_text">Price</div>
          <input type="number" v-model="myItem.price" class="form-control w-100">
        </div>
        <div class="col-12 mb-3">
          <div class="label wrap_text">Stock Remaining (leave empty for no limit)</div>
          <input type="number" v-model="myItem.quantity" class="form-control w-100">
        </div>
        <div class="col-12 mb-3">
          <div class="label wrap_text">Select Category</div>
          <select v-model="myItem.category" class="form-control hiddenSelect">
            <option>--Select--</option>
            <option v-for="(category, index) in categories" :key="index" :value="category">{{category}}</option>
          </select>
          <!-- <multiselect v-model="myItem.category" tag-placeholder="Add this as new category" placeholder="Search or add a category" :options="categories" :multiple="false" :taggable="true" @tag="addCategory"></multiselect> -->
        </div>
        <!-- <div class="col-12 mb-2">
          <div class="label wrap_text bold">Dimensions</div>
        </div>
        <div class="col-12 pl-4 mb-1">
          <div class="label wrap_text">Height (mm)</div>
          <input type="number" v-model="myItem.height" class="form-control w-100">
        </div>
        <div class="col-12 pl-4 mb-1">
          <div class="label wrap_text">Width (mm)</div>
          <input type="number" v-model="myItem.width" class="form-control w-100">
        </div>
        <div class="col-12 pl-4 mb-1">
          <div class="label wrap_text">Length (mm)</div>
          <input type="number" v-model="myItem.length" class="form-control w-100">
        </div>
        <div class="col-12 pl-4 mb-1">
          <div class="label wrap_text">Weight (kg)</div>
          <input type="number" v-model="myItem.weight" class="form-control w-100">
        </div> -->
        <div class="col-12 mt-3 mb-2">
          <div class="label wrap_text bold">Variations</div>
        </div>
        <div class="col-12 pl-4 mb-3">
          <product-variation v-for="(variation, index) in myItem.variations" :key="index" :index="index" :variation="variation" @removeVariation="removeVariation"></product-variation>
          <div class="row mx-0 my-2 mb-3 justify-content-end">
            <div class="col-auto material-icons pointer p-0 ion" @click="addVariation">
              add_circle_outline
            </div>
          </div>
        </div>
        <div class="col-12 my-3">
          <div class="row m-0 justify-content-end">
            <div class="col-auto p-0">
              <button type="button" class="btn btn-delete font14" @click="deleteProduct">Delete</button>
            </div>
            <div class="col p-0">
              <div class="row m-0 justify-content-end">
                <div class="col-auto pr-0">
                  <button type="button" class="btn btn-secondary font14" @click="$emit('close', false)">{{btnN}}</button>
                </div>
                <div class="col-auto pr-0">
                  <button type="button" class="btn btn-primary font14" @click="$emit('close', myItem)">{{btnY}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-product-img-edit :item="myItem" :key="myItem.id" @save="updateImg" @close="editImage = false" v-if="editImage"></app-product-img-edit>
    <app-product-img-edit :item="myItem" :key="myItem.id" @save="updateImgGallery" @close="editGallery = false" v-if="editGallery" :multiple="true"></app-product-img-edit>
    <div class="popup" v-if="isDelete">
      <div class="row m-0 h-100 w-100 align-items-center justify-content-center">
        <div class="col-10 col-md-6 col-xl-5 form_holder p-4">
          <div class="row m-0">
            <div class="col-12 p-0">
              <h4 class="text-center">Are you sure you want to delete this product?</h4>
            </div>
            <div class="col-12 p-0 mt-3">
              <div class="row m-0 justify-content-end">
                <div class="col-auto pr-0">
                  <button type="button" class="btn btn-outline font14" @click="isDelete = false">Cancel</button>
                </div>
                <div class="col-auto pr-0">
                  <button type="button" class="btn btn-primary font14" @click="confirmDelete">Yes, Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Multiselect from 'vue-multiselect'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'EditProduct',
  props: {
    item: {
      type: Object,
      required: true
    },
    btnN: {
      type: String,
      default: 'Cancel'
    },
    btnY: {
      type: String,
      default: 'Confirm'
    }
  },
  computed: {
    ...mapGetters(['categories'])
  },
  components: {
    // Multiselect,
    'app-product-img-edit': () => import('@/components/product/ProductImgGallery.vue'),
    'product-variation': () => import('@/components/product/ProductVariation.vue')
  },
  data () {
    return {
      myItem: null,
      editImage: false,
      editGallery: false,
      isDelete: false
    }
  },
  created () {
    this.myItem = { ...this.item, variations: this.item.variations || [{ 'name': '', 'price': null }] }
  },
  methods: {
    ...mapActions(['addCategory']),
    updateImg (prod) {
      console.log(prod.thumbnail_url)
      this.myItem.thumbnail_url = prod.thumbnail_url
      this.editImage = false
    },
    updateImgGallery (images) {
      this.myItem.images = images
      this.editGallery = false
    },
    disableIt () {
      if (typeof this.myItem.disabled === 'undefined') {
        this.myItem.disabled = false
      }
      this.myItem.disabled = !this.myItem.disabled
    },
    featureIt () {
      if (typeof this.myItem.featured === 'undefined') {
        this.myItem.featured = false
      }
      this.myItem.featured = !this.myItem.featured
    },
    soldOut () {
      this.myItem.soldOut = !this.myItem.soldOut
    },
    addVariation () {
      const variation = { 'name': '', 'price': this.myItem.price }
      this.myItem.variations.push(variation)
    },
    removeVariation (val) {
      if (val > -1) {
        this.myItem.variations.splice(val, 1)
      }
    },
    deleteProduct () {
      this.isDelete = true
    },
    confirmDelete () {
      this.isDelete = false
      this.myItem.isDeleted = true
      this.$emit('close', this.myItem)
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.form-control.title {
  height: 46px;
  background-color: var(--light-color);
  border: none;
  font-weight: bold;
  font-size: 20px;
}
.close {
  position: absolute;
  top: -25px;
  right: 15px;
}
.img_bg {
  background-color: var(--light-color-off);
}
.edit_icon {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  bottom: 0;
  left: 0;
  z-index: 2;
  color: var(--dark-color);
  background-color: var(--light-color-07);
}
.dark-mode .edit_icon {
  color: var(--light-color);
  background-color: var(--dark-color-07);
}
.popup {
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
